import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import vdc_logo from "./vdc_logo.png";
import useAuth from "./useAuth";
const Sidebar = () => {
     const navigate = useNavigate();
     const [isMini, setIsMini] = useState(true); // Sidebar is mini by default
     useAuth();
     const handleLogout = () => {
          localStorage.removeItem("jwt_token");
          navigate("/");
     };
     return (
          <aside
               className={`sidebar sidebar-base sidebartab sidebar-color sidebar-default navs-pill-all ${isMini ? "sidebar-mini" : ""
                    }`}
               id="first-tour"
               data-toggle="main-sidebar"
               data-sidebar="responsive"
               onMouseEnter={() => setIsMini(false)} // Remove class on hover
               onMouseLeave={() => setIsMini(true)} // Add class back when hover out
          >
               <div className="sidebar-header d-flex align-items-center justify-content-start position-relative">
                    <Link to="/" className="navbar-brand me-5 pt-3">
                         {/* Logo Start */}
                         <div className="logo-main">
                              <img
                                   className="logo-normal img-fluid mb-3"
                                   src="/assets/images/vdc_logo.png"
                                   height="30"
                                   alt="logo"
                              />
                              <span className="ms-2 brand-name">VDC</span>
                         </div>
                         {/* Logo End */}
                    </Link>
               </div>
               <div className="sidebar-body pt-0 data-scrollbar">
                    <div className="sidebar-list">
                         {/* Sidebar Menu Start */}
                         <ul className="navbar-nav iq-main-menu" id="sidebar-menu">
                              <li className="nav-item static-item ms-2">
                                   <a
                                        className="nav-link static-item disabled text-start"
                                        href="#"
                                        tabIndex="-1"
                                   >
                                        <span className="default-icon">Dashboard</span>
                                        <span
                                             className="mini-icon"
                                             data-bs-toggle="tooltip"
                                             title="Home"
                                             data-bs-placement="right"
                                        >
                                             -
                                        </span>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link active" to="/">
                                        <i
                                             className="ri-hospital-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Doctor Dashboard</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/doctors_list">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Doctors List</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/june_doctors_list">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Target Doctors List</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/doctorAttendance">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Doctors Attendance</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/attendanceReports">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Attendance Reports</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/testcategories_list">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Test Category</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/tests_list">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Tests List</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/users_list">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Users List</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/invoice_gen">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Invoice Generation</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/status">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Invoice Approval</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/invoice_print">
                                        <i
                                             className="ri-home-8-fill"
                                             data-bs-toggle="tooltip"
                                             title="Dashboard"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Invoice Print</span>
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <button className="nav-link btn btn-link" onClick={handleLogout}>
                                        <i
                                             className="ri-logout-box-r-line"
                                             data-bs-toggle="tooltip"
                                             title="Logout"
                                             data-bs-placement="right"
                                        ></i>
                                        <span className="item-name">Logout</span>
                                   </button>
                              </li>
                              <li>
                                   <hr className="hr-horizontal" />
                              </li>
                         </ul>
                         {/* Sidebar Menu End */}
                    </div>
               </div>
               <div className="sidebar-footer"></div>
          </aside>
     );
};
export default Sidebar;
